/**
 * Display-layer scrub for internal document reference codes (BNK-014, FAQ-093).
 *
 * Codes are machinery: retrieval, logging, and stored message content keep them
 * untouched. Members must never read one. This runs at render time only.
 *
 * When a title is known for a code, the code is replaced by the title. When it
 * is not, the code (and any wrapping parentheses or "see " lead-in) is removed
 * and the surrounding spacing tidied.
 */
const CODE = "[A-Z]{2,5}-[0-9]{2,5}";
const PAREN_RE = new RegExp(`\\s*\\((?:see\\s+)?(?:${CODE})(?:\\s*,\\s*(?:${CODE}))*\\)`, "g");
const BARE_RE = new RegExp(`\\b${CODE}\\b`, "g");

export function stripDocCodes(
  text: string,
  titles?: Record<string, string>,
): string {
  if (!text) return text || "";
  const lookup = titles || {};

  let out = text.replace(PAREN_RE, (whole) => {
    const ids = whole.match(new RegExp(CODE, "g")) || [];
    const named = ids.map((id) => lookup[id]).filter(Boolean);
    return named.length ? ` (${named.join(", ")})` : "";
  });

  out = out.replace(BARE_RE, (id) => lookup[id] || "");

  // Tidy the gaps a removal can leave behind.
  return out
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\(\s*\)/g, "")
    .replace(/,\s*,/g, ",")
    .replace(/\s+(?:and|or)\s+(?=[,.;:!?])/gi, "")
    .replace(/,\s+(?:and|or)\s+(?=\s|$)/gi, "")
    .replace(/\s+([,.;:!?])/g, "$1")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/[ \t]+\n/g, "\n")
    .trim();

}
